import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { defineMessages, useIntl } from 'react-intl';

import { isType } from '@sorare/core/src/lib/gql';

import { AccountEntry } from '#src/components/mySorare/TransactionsHistory/SpentFiatPaymentIntents/AccountEntry/index.tsx';
import { TransactionsBid } from '#src/components/mySorare/TransactionsHistory/common/TransactionsBid/index.tsx';

import type { Bid_authorizationRequest } from './__generated__/index.graphql.ts';

const messages = defineMessages({
  title: {
    defaultMessage: 'Bid',
  },
});

type Props = {
  payment: Bid_authorizationRequest;
};

export const Bid = ({ payment }: Props) => {
  const { operation } = payment;
  const { formatMessage } = useIntl();

  if (!isType(operation, 'TokenBid')) {
    return null;
  }

  return (
    <AccountEntry payment={payment} title={formatMessage(messages.title)}>
      <TransactionsBid tokenBid={operation} />
    </AccountEntry>
  );
};

Bid.fragments = {
  payment: gql`
    fragment Bid_authorizationRequest on AuthorizationRequest {
      id
      ...AccountEntry_authorizationRequest
      operation {
        ... on TokenBid {
          id
          ...TransactionsBid_tokenBid
        }
      }
    }
    ${AccountEntry.fragments.payment}
    ${TransactionsBid.fragments.tokenBid}
  ` as TypedDocumentNode<Bid_authorizationRequest>,
};
